export default __webpack_public_path__ + "static/eco-alliance-badge-723a0c58b54b35cf016801609036aba7.svg";